<template>
  <span class="display-value">
    <v-chip
        v-if="isEmpty"
        class="display-value__chip display-value__chip--empty"
        small
        label
    >
      Não informado
    </v-chip>
    <template v-else-if="Array.isArray(value)">
      <v-chip
          v-for="(item, index) in value"
          :key="`display-value-${index}`"
          class="display-value__chip display-value__chip--item"
          small
          label
      >
        {{ formatValue(item) }}
      </v-chip>
    </template>
    <v-chip
        v-else-if="typeof value === 'boolean'"
        :class="['display-value__chip', value ? 'display-value__chip--yes' : 'display-value__chip--no']"
        small
        label
    >
      {{ value ? 'Sim' : 'Não' }}
    </v-chip>
    <span v-else>{{ formatValue(value) }}</span>
  </span>
</template>

<script>
export default {
  name: 'DisplayValue',
  props: {
    value: {
      required: false,
    },
  },
  computed: {
    isEmpty() {
      return this.value === null || this.value === undefined || this.value === '' ||
          (Array.isArray(this.value) && this.value.length === 0);
    },
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return 'Não informado';
      }
      if (typeof value !== 'object') {
        return value;
      }
      if (value.name || value.fullname || value.label) {
        return value.name || value.fullname || value.label;
      }
      if (value.value) {
        return value.value;
      }
      return Object.values(value).filter((item) => item !== null && item !== undefined && item !== '').join(' - ') ||
          'Não informado';
    },
  },
};
</script>

<style scoped>
.display-value {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  word-break: break-word;
}

.display-value__chip {
  margin: 1px;
  max-width: 100%;
  white-space: normal;
  height: auto;
  min-height: 22px;
}

.display-value__chip--empty {
  background-color: #f1f5f0 !important;
  border: 1px solid #6b886a;
  color: #28432a !important;
}

.display-value__chip--item {
  background-color: #6b886a !important;
  color: #ffffff !important;
}

.display-value__chip--yes {
  background-color: #557155 !important;
  color: #ffffff !important;
}

.display-value__chip--no {
  background-color: #28432a !important;
  color: #ffffff !important;
}
</style>
